import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import TextField from '@material-ui/core/TextField';
import { useAlert } from 'react-alert';
import { PageTitle, PaperWithTitle, PrimaryButton } from '../../../components';
import { useAuth } from '../../../../model/hooks';
export const ChangePass = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const reactAlert = useAlert();
    const { updatePassword, loading } = useAuth();
    const [nowPassword, setNowPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const onClickChange = async () => {
        try {
            await updatePassword(nowPassword, newPassword);
            reactAlert.success(t('パスワードを変更しました。'));
            history.push('/home/account');
        }
        catch (e) {
            if (e instanceof Error) {
                reactAlert.error(e.message);
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('アカウント情報')),
        React.createElement(SGrid, { container: true, justify: "center" },
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(PaperWithTitle, { title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4", titleAlign: "center" },
                    React.createElement(SGrid, { container: true, spacing: 3, justify: "center" },
                        React.createElement(Grid, { item: true, xs: 11 },
                            React.createElement(TextField, { required: true, label: t('現在のパスワード'), value: nowPassword, fullWidth: true, onChange: (e) => setNowPassword(e.target.value) })),
                        React.createElement(Grid, { item: true, xs: 11 },
                            React.createElement(TextField, { required: true, label: t('新しいパスワード'), value: newPassword, fullWidth: true, onChange: (e) => setNewPassword(e.target.value) })),
                        React.createElement(Grid, { item: true, xs: 6, style: { marginTop: '16px' } },
                            React.createElement(PrimaryButton, { onClick: onClickChange, loading: loading, fullWidth: true, disabled: nowPassword === '' || newPassword === '' }, t('変更する')))))))));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
